import { FC, memo } from 'react'
import { Container, SliderContainer } from './styles'
import GridCard from '../../common/grid-card'
import { Title, TitleContainer } from '../common/styles'
import { useTranslation } from '../../../hooks/locale'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { useContinueYourSearchListings } from '../../../hooks/search'
import isEmpty from 'lodash/isEmpty'
import PropertyGridSkeleton from './skeleton'
import { useResponsiveCards } from '../../../hooks/responsive'
import { cardEventCategories, pageTypeEventCategories } from '../../../services/analytics-service/categories'
import { Offer } from '../../../models/common/offers-model'
import { SuitablesModel } from '../../../models/common/suitables-model'
import { EmblaCarousel } from '../../common/embla-carousel'

interface Props {
    url: string
    breadcrumbModel: BreadcrumbListTransport
    offerModel: Offer
    suitablesModel: SuitablesModel
}

const ContinueSearchWidget: FC<Props> = ({ url, breadcrumbModel, offerModel, suitablesModel }) => {
    const { listings, isLoading } = useContinueYourSearchListings()
    const { t } = useTranslation()
    const heading = t('pages.home.continueSearch.heading')

    const visibleSlides = useResponsiveCards()
    const slidesToScroll = Math.floor(visibleSlides)

    if (isLoading) {
        return (
            <Container id="continue-search">
                <TitleContainer>
                    <Title>{heading}</Title>
                </TitleContainer>
                <PropertyGridSkeleton />
            </Container>
        )
    }

    const { objects = [] } = listings || {}

    if (isEmpty(objects)) {
        return null
    }

    return (
        <Container id="continue-search">
            <TitleContainer>
                <Title>{heading}</Title>
            </TitleContainer>
            <SliderContainer>
                <EmblaCarousel
                    slides={objects.map((recommendedObject, index) => (
                        <GridCard
                            key={recommendedObject.id}
                            index={index}
                            listingObject={recommendedObject}
                            requestUrl={url}
                            pageName={pageTypeEventCategories.HOME}
                            sectionName={cardEventCategories.sections.CONTINUE_SEARCH}
                            breadcrumbModel={breadcrumbModel}
                            offerModel={offerModel}
                            suitablesModel={suitablesModel}
                            showFeatures={false}
                        />
                    ))}
                    visibleSlides={visibleSlides}
                    slidesToScroll={slidesToScroll}
                    showNav
                    navVariant="top-right"
                    navPosition={{ desktopTop: '-3.8rem', wideTop: '-3.8rem' }}
                />
            </SliderContainer>
        </Container>
    )
}

export default memo(ContinueSearchWidget)
